import type { DeviceGeneralStatus } from '@cobliteam/api-lib/src/__generated__/graphql';

import Button from '@cobliteam/ui/components/Button';
import { ReactComponent as FilterIcon } from '@cobliteam/ui/icons/filters/filter_alt_cb.svg';

interface DeviceStatusTitleProps {
  selectedStatus: DeviceGeneralStatus[];
  size?: 'condensed' | 'regular';
}

const DeviceStatusTitle = ({ selectedStatus, size }: DeviceStatusTitleProps) => {
  return (
    <Button size={size} variant='text' type='button' startIcon={<FilterIcon />}>
      Status {selectedStatus?.length > 0 ? `(${selectedStatus?.length})` : ''}
    </Button>
  );
};

export default DeviceStatusTitle;
